import { useMemo } from 'react';

import { IEnvironmentProvider } from 'react-relay';

import { getAggRelayEnvironment } from './AggRelayEnvironment';

export function useAggRelayEnvironmentProvider(): IEnvironmentProvider<NonNullable<unknown>> {
	return useMemo(
		() => ({
			getEnvironment() {
				return getAggRelayEnvironment();
			},
		}),
		[],
	);
}
